<template>
  <section>
    <!-- <base-card> -->
    <div
      class="container-fluid mt-5 p-0 wow fadeIn d-flex flex-column align-items-center"
      data-wow-delay="0.35s"
    >
      <!-- <h1 class="display-4 mt-5"></h1> -->

      <h1 class="display-4">Page not found</h1>
      <a class="h2" href="https://gartenbau-gazi.de" target="_blank"
        >Click here!</a
      >
    </div>
    <!-- </base-card> -->
  </section>
</template>
